import debounce from 'debounce'
import noUiSlider from 'nouislider'

import '../../../node_modules/nouislider/distribute/nouislider.min.css'
import './PollNumberSlider.scss'
import Utilities from '../../utils/Utilities'

import React from 'react'
import { IPartyNumberMap } from '../../models/TypeHelper'
import PollSliderAnnotations from './PollSliderAnnotations'
import { connect } from 'react-redux'
import { IReduxState } from '../../utils/ReduxStore'

interface IStateProps {
  lastReset: number
}

interface IProps extends IStateProps {
  annotations?: boolean
  polls: IPartyNumberMap
  handlePollingUpdate: (polls: IPartyNumberMap) => void
  resultsWillRandomize?: boolean
  compact?: boolean
}

interface IState {
  isMounted: boolean
  polls: IPartyNumberMap
}

class PollNumberSlider extends React.Component<IProps, IState> {
  protected sliderRef: React.RefObject<HTMLDivElement>

  public constructor(props: IProps) {
    super(props)

    this.state = {
      isMounted: false,
      polls: this.props.polls
    }

    this.sliderRef = React.createRef()

    this.debouncerFunction = debounce(this.debouncerFunction.bind(this), 10)
    // this.debouncerFunction = this.debouncerFunction.bind(this)
  }

  protected get noUiSlider(): noUiSlider.noUiSlider {
    return ((this.sliderRef.current as unknown) as noUiSlider.Instance)
      .noUiSlider
  }

  public componentDidUpdate(prevProps: IProps): void {
    // TODO / FIX: THIS IS THE SLOW PART, BUT NEEDS TO BE RESET
    if (prevProps.lastReset !== this.props.lastReset) {
      this.setState({ polls: this.props.polls }, (): void => {
        const sliderValues = this._getSliderValuesFromPolls(this.props.polls)
        this.noUiSlider.set(sliderValues)
      })
    }
  }

  public componentDidMount(): void {
    const start = this._getSliderValuesFromPolls(this.props.polls)
    const partyKeys = Object.keys(this.props.polls)

    if (start.length > 0 && this.sliderRef.current && !this.state.isMounted) {
      this.setState({ isMounted: true })
      const sliderRef = this.sliderRef.current

      const connectArr = partyKeys.map((): boolean => true)
      // connectArr.push(true)

      const theSlider = noUiSlider.create(sliderRef, {
        start: start,
        connect: connectArr,
        step: 0.1,
        range: {
          min: [0.0],
          max: [100.0]
        }
      })
      // Set up connect colours
      const connect = sliderRef.querySelectorAll('.noUi-connect')
      for (let i = 0; i < connect.length; i++) {
        connect[i].classList.add(`party-${partyKeys[i]}-bg`)
      }

      this.noUiSlider.on('slide', (): void => {
        const polls: IPartyNumberMap = {}
        partyKeys.forEach((partyKey): void => {
          polls[partyKey] = 0
        })
        const values = theSlider.get() as string[]
        values.unshift('0.0')
        values.push('100.0')
        for (let i = 1; i < values.length; i++) {
          const partyValue = +values[i] - +values[i - 1]
          const party = partyKeys[i - 1]
          polls[party] = +Utilities.formatDecimal(partyValue / 100, 3)
        }
        // const debouncedFunction = this.props.handlePollingUpdate
        // debounce((this.debouncerFunction as unknown) as Function, 1000)
        this.setState({ polls })
        this.debouncerFunction(polls)
      })

      this.noUiSlider.on('end', (): void => {
        console.log('ended')
      })
    }
  }

  protected debouncerFunction(polls: IPartyNumberMap): void {
    this.props.handlePollingUpdate(polls)
  }

  protected _getSliderValuesFromPolls(polls: IPartyNumberMap): number[] {
    const start = Object.keys(polls).map(
      (partyKey): number => 100 * polls[partyKey]
    )
    start.pop() // Remove the last item
    for (let i = 1; i < start.length; i++) {
      start[i] = start[i] + start[i - 1]
    }
    return start
  }

  protected _getPollsFromSliderValues(): IPartyNumberMap {
    const polls = Object.assign({}, this.props.polls)
    const pollKeys = Object.keys(polls)
    const sliderValues = [0, ...(this.noUiSlider.get() as string[]), 100].map(
      (val): number => +val
    )

    // Keys are preserved in insertion order, so we can rely on the ordering to
    // reverse-map.
    for (let i = 1; i < sliderValues.length; i++) {
      const key = pollKeys[i - 1]
      polls[key] = sliderValues[i] - sliderValues[i - 1]
    }

    return polls
  }

  public render(): JSX.Element {
    const { annotations, compact } = this.props
    return (
      <div
        id="polling-entry-interface"
        className={Utilities.classIf(compact, 'compact')}
      >
        <div className="row">
          {annotations && <PollSliderAnnotations polls={this.state.polls} />}
          <div className="col-12">
            <div id="slider" ref={this.sliderRef} />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  lastReset: state.lastReset
})

export default connect(mapStateToProps)(PollNumberSlider)
